import api from './api';

// Pre-op questionnaires — the health questions a booked patient answers before
// surgery. Staff calls need a login; the public ones are the patient's link.
const preopService = {
  // view: waiting | to_review | reviewed | expired | all → { questionnaires, counts }
  list: ({ view = 'all', bid, patientId } = {}) =>
    api.get('/preop', { params: { view, bid: bid || undefined, patient_id: patientId || undefined } }).then((r) => r.data),
  // with answers, flags and summary
  get: (id) => api.get(`/preop/${id}`).then((r) => r.data.questionnaire),
  // → { questionnaire, link, emailed, email_error }
  send: ({ bid, patientId, email }) => api.post('/preop', { bid, patient_id: patientId, email: email || undefined }, { timeout: 60000 }).then((r) => r.data),
  resend: (id, email) => api.post(`/preop/${id}/send`, { email: email || undefined }, { timeout: 60000 }).then((r) => r.data),
  cancel: (id) => api.post(`/preop/${id}/cancel`).then((r) => r.data.questionnaire),
  review: (id, note) => api.post(`/preop/${id}/review`, { note }).then((r) => r.data.questionnaire),

  // The practice's questions (administrators) — see backend preopFormController.
  getForm: () => api.get('/preop/form').then((r) => r.data),
  saveDraft: (sections) => api.put('/preop/form/draft', { sections }).then((r) => r.data),
  discardDraft: () => api.delete('/preop/form/draft').then((r) => r.data),
  publishForm: (note) => api.post('/preop/form/publish', { note: note || undefined }).then((r) => r.data),
  getFormVersion: (version) => api.get(`/preop/form/versions/${version}`).then((r) => r.data),

  publicLoad: (token) => api.get(`/public/preop/${encodeURIComponent(token)}`).then((r) => r.data),
  publicSave: (token, answers) => api.put(`/public/preop/${encodeURIComponent(token)}`, { answers }).then((r) => r.data),
  publicComplete: (token, payload) => api.post(`/public/preop/${encodeURIComponent(token)}`, payload).then((r) => r.data),
};

export default preopService;
